import React from 'react';
import { formatSentimentLabel } from '../utils/geoPresentation';
import { getSentimentPillStyle } from '../../../utils/pillStyles';

export default function GeoSentimentPill({ value }) {
  const label = formatSentimentLabel(value);
  return (
    <span className="pill" style={getSentimentPillStyle(value)}>
      {label}
    </span>
  );
}
